import { observer } from 'mobx-react';
import * as React from 'react';
import { PropsWithChildren } from 'react';
import Header from '../header/header';
import './layout.scss';

export const Layout = observer(({ children }: PropsWithChildren) => {
  return (
    <>
      <Header />
      <div className="layout-container">{children}</div>
    </>
  );
});
